import { useAppLocale } from '~/composables/custom/useAppLocale';
import { useMagnolia } from '~/composables/custom/useMagnolia/useMagnolia';

export default defineNuxtRouteMiddleware((to) => {
  const { country: countryCode } = useAppLocale();
  const { atMagnolia } = useMagnolia();

  if ((to.path !== '/' && to.path.endsWith('/')) || (to.path.includes(`${countryCode}/Home`) && !atMagnolia.value)) {
    const { path, query, hash } = to;
    const regex = new RegExp(atMagnolia.value ? '\\/+$' : `(?:/${countryCode}/Home)|/$`);
    const nextPath = path.replace(regex, '') || '/';
    const nextRoute = { path: nextPath, query, hash };
    return navigateTo(nextRoute, { redirectCode: 301 });
  }
});
